// modules/routes.js
import React from 'react';

// Import all routes dynamically
const modulesContext = require.context('./', true, /routes\.js$/);

// Aggregate all routes
const ModuleRoutes = () => {
  const routes = [];

  modulesContext.keys().forEach((filePath) => {
    const moduleRoutes = modulesContext(filePath).default;
    if (Array.isArray(moduleRoutes)) {
      routes.push(...moduleRoutes); // Merge routes into the main array
    }
  });

  return routes;
};

export default ModuleRoutes;
